<template>
  <div id="corp-manning-vessel-list" class="h-full">
    <!-- 右上アクションボタン領域 -->

    <div class="flex flex-wrap justify-between items-center">
      <div class="flex w-1/3 justify-start my-4">
        <div class="aisea-text-18-600-dark-gray">作業種別管理</div>
      </div>
      <div class="flex w-2/3 justify-end items-center">
        <vs-button
          icon="add"
          :color="AISEA_COLOR.BLUE"
          type="border"
          style="margin: 0 0.6rem; height: 2.7rem;"
          :disabled="addButtonDisabled"
          @click="
            () => {
              setActionDialogAdd();
              showActionDialog = true;
            }
          "
          ><span class="aisea-text-14-400-blue">新規登録</span></vs-button
        >
      </div>
    </div>

    <vs-divider :color="AISEA_COLOR.LIGHT_GRAY" class="my-0" />

    <!-- AgGrid Table -->
    <ag-grid-vue
      :components="components"
      :gridOptions="gridOptions"
      class="ag-theme-material w-full ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="tableData"
      domLayout="autoHeight"
      rowSelection="multiple"
      colResizeDefault="shift"
      :rowDragManaged="false"
      :animateRows="true"
      :floatingFilter="false"
      :suppressMovableColumns="true"
      :suppressPaginationPanel="true"
      :suppressDragLeaveHidesColumns="true"
      :suppressCellFocus="true"
      :suppressRowClickSelection="true"
      :suppressNoRowsOverlay="false"
      @rowDragEnd="onRowDragEnd"
    />

    <vs-prompt
      :title="actionDialogTitle"
      :color="AISEA_COLOR.BLUE"
      buttons-hidden
      :active.sync="showActionDialog"
      class="task-kind-list-add-dialog"
    >
      <div class="required-info-edit-form-container">
        <div class="mb-5">
          必要事項を入力してください。「<span class="required-mark">*</span
          >」は入力必須項目です。
        </div>

        <div class="form-item">
          <div class="form-item-title">
            作業種別名<span class="required-mark">*</span>
          </div>
          <vs-input
            class="w-full"
            v-model="dialogTaskKindName"
            :color="AISEA_COLOR.BLUE"
            :disabled="isEditFormDisabled"
          />
        </div>

        <div class="form-item">
          <div class="form-item-title">
            作業種別カラー<span class="required-mark">*</span>
          </div>
          <div class="input-area">
            <div v-if="isEditFormDisabled">
              <color-chip
                class="color-chip m-2"
                :color="dialogSelectedColor"
                :focused="true"
              ></color-chip>
            </div>
            <div v-else class="flex flex-wrap">
              <div
                class="cursor-pointer"
                v-for="color in colorOptions"
                @click="onClickColorChip(color)"
                :key="color"
              >
                <color-chip
                  class="color-chip m-2"
                  :color="color"
                  :focused="dialogSelectedColor == color"
                ></color-chip>
              </div>
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-item-title">
            デフォルトの作業時間<span class="required-mark">*</span>
          </div>
          <div class="input-area">
            <dropdown-select
              class="filter-input"
              :selectOptions="defaultWorkingMinutesOptions"
              :selectedValue.sync="dialogDefaultWorkingMinutes"
              placeholder="作業時間を選択してください"
              :border="true"
            ></dropdown-select>
          </div>
        </div>

        <div class="form-item">
          <div class="form-item-title mb-2">
            打刻時の選択肢への表示有無<span class="required-mark">*</span>
          </div>
          <div class="input-area my-3">
            <vs-radio
              class="mr-5"
              v-model="dialogShowOnCreating"
              :vs-value="true"
              vs-name="1"
              :color="AISEA_COLOR.BLUE"
            >
              表示する
            </vs-radio>
            <vs-radio
              v-model="dialogShowOnCreating"
              :vs-value="false"
              vs-name="1"
              :color="AISEA_COLOR.BLUE"
            >
              表示しない
            </vs-radio>
          </div>
          <span class="caution-text"
            >※「表示する」を選択した場合、打刻時の作業種別選択肢に表示されます。「表示しない」を選択した場合、選択肢として表示されません。</span
          >
        </div>

        <div class="form-item">
          <div class="form-item-title mb-2">
            労務管理記録簿での集計有無<span class="required-mark">*</span>
          </div>
          <div class="input-area my-3">
            <vs-radio
              class="mr-5"
              v-model="dialogShowOnRecordBook"
              :vs-value="true"
              vs-name="2"
              :color="AISEA_COLOR.BLUE"
            >
              集計する
            </vs-radio>
            <vs-radio
              v-model="dialogShowOnRecordBook"
              :vs-value="false"
              vs-name="2"
              :color="AISEA_COLOR.BLUE"
            >
              集計しない
            </vs-radio>
          </div>
          <span class="caution-text"
            >※「集計する」を選択した場合、労務管理記録簿上で本作業種別のみの作業時間を集計します。</span
          >
        </div>
      </div>
      <span class="validation-label">{{ getDialogValidationMessage }}</span>
      <div class="flex w-full justify-end items-center">
        <div class="m-3 mb-0">
          <vs-button
            type="border"
            style="width: 6rem; padding: 0.4rem"
            @click="onActionDialogCancel"
            :color="AISEA_COLOR.GRAY"
            >キャンセル</vs-button
          >
        </div>
        <div class="m-3 mb-0">
          <vs-button
            :color="AISEA_COLOR.BLUE"
            style="width: 6rem; padding: 0.4rem"
            @click="
              () => {
                if (actionMode == 'edit') {
                  onEdit();
                } else if (actionMode == 'add') {
                  onAdd();
                }
              }
            "
            :disabled="getDialogValidationMessage != null"
            >保存</vs-button
          >
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import CellRendererColorHex from "./cell-renderer/CellRendererColorHex.vue";
import CellRendererRowActionButtons from "./cell-renderer/CellRendererRowActionButtons.vue";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseTimesheetTaskApi = AiseaApiFactory.get(
  "enterpriseTimesheetTask"
);
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import DropdownSelect from "../components/DropdownSelect.vue";
import moment from "moment";
import ColorChip from "../components/ColorChip.vue";

import { TASK_KIND_COLOR_PALETTE } from "@/config/const.js";

export default {
  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererColorHex,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererRowActionButtons,
    DropdownSelect,
    ColorChip,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    activeSidebarCrew: Boolean,
    activeTab: Number,
  },
  data() {
    return {
      colorOptions: TASK_KIND_COLOR_PALETTE.map(element => element.normal),

      defaultWorkingMinutesOptions: [
        { text: "15分", value: 15 },
        { text: "30分", value: 30 },
        { text: "60分", value: 60 },
        { text: "90分", value: 90 },
        { text: "120分", value: 120 },
        { text: "180分", value: 180 },
        { text: "240分", value: 240 },
      ],

      dialogTaskKindName: "",
      dialogSelectedColor: null,
      dialogDefaultWorkingMinutes: null,
      dialogShowOnCreating: true,
      dialogShowOnRecordBook: true,
      dialogTargetRowData: null,

      mandatoryRoleFormItems: [null],
      optionalRoleFormItems: [],

      tableData: [],

      showActionDialog: false,

      actionMode: null, // edit or add or transfer
      actionDialogTitle: "",

      updatedTaskIds: [],

      gridApi: null,
      gridOptions: {
        localeText: {
          noRowsToShow:
            '<div id="no-rows-manning-vessel-list" class="aisea-text-16-400-black">表示する作業種別がありません</div>',
        },
        context: {
          componentParent: this,
        },
      },
      domLayout: "autoHeight",
      pageSize: 25,
      sortType: null,
      sortColumnKey: null,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [],
      components: {
        CellRendererColorHex,
        CellRendererRowActionButtons,
      },

      prevRoute: null,
    };
  },
  async created() {
    this.initializeColumnDef();
    await this.fetchTableData();
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  computed: {
    addButtonDisabled() {
      return this.tableData.length >= 50;
    },
    getDialogValidationMessage() {
      // 入力されていない項目があるかのチェック
      if (
        !this.dialogTaskKindName ||
        !this.dialogDefaultWorkingMinutes ||
        !this.dialogSelectedColor
      ) {
        return "入力されていない項目があります";
      }

      // 作業種別名の長さチェック（新規タスクまたはカスタムタスクの場合）
      let isNewOrCustomTask =
        this.dialogTargetRowData == null || this.dialogTargetRowData.is_custom;
      if (isNewOrCustomTask && this.dialogTaskKindName.length > 10) {
        return "作業種別名は10文字以下で入力してください";
      }

      return null;
    },
    isEditFormDisabled() {
      return this.dialogTargetRowData
        ? !this.dialogTargetRowData.is_custom
        : false;
    },
  },
  methods: {
    onRowDragMove(event) {
      const movingNode = event.node;
      const overNode = event.overNode;
      const rowNeedsToMove = movingNode !== overNode;
      if (rowNeedsToMove) {
        // the list of rows we have is data, not row nodes, so extract the data
        const movingData = movingNode.data;
        const overData = overNode.data;
        const fromIndex = this.tableData.indexOf(movingData);
        const toIndex = this.tableData.indexOf(overData);
        const newStore = this.tableData.slice();
        moveInArray(newStore, fromIndex, toIndex);
        this.tableData = newStore;
        this.gridApi.setRowData(newStore);
        this.gridApi.clearFocusedCell();
      }
      function moveInArray(arr, fromIndex, toIndex) {
        const element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
      }
    },

    moveElement(arr, element, newIndex) {
      const index = arr.indexOf(element);
      if (index === -1) return; // 要素が見つからない場合は何もしない
      arr.splice(index, 1); // 要素を削除
      arr.splice(newIndex, 0, element); // 新しい位置に要素を挿入
    },
    onRowDragEnd(data) {
      const sortRowId = data.node.data.id;
      const sortRowIndex = data.overIndex;
      let originalTaskIds = this.tableData.map(element => {
        return element.id;
      });
      let sortedTaskIds = this.tableData.map(element => {
        return element.id;
      });
      this.moveElement(sortedTaskIds, sortRowId, sortRowIndex);
      if (originalTaskIds.toString() == sortedTaskIds.toString()) {
        return;
      }
      this.onManualSort(sortedTaskIds);
    },
    onClickColorChip(color) {
      this.dialogSelectedColor = color;
    },
    initializeColumnDef() {
      const initialColumnDefs = [
        {
          headerName: "No.",
          field: "sort_order",
          rowDrag: true,
          minWidth: 85,
          maxWidth: 85,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "作業種別名",
          field: "label",
          minWidth: 160,
          flex: 1,
          sortable: false,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "作業種別カラー",
          field: "color_hex",
          minWidth: 140,
          flex: 1,
          cellRenderer: "CellRendererColorHex",
          sortable: false,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "デフォルトの時間単位",
          field: "default_working_minutes",
          minWidth: 180,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
        },
        {
          headerName: "打刻時の表示有無",
          field: "show_on_creating",
          minWidth: 160,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
          valueGetter: params => {
            return params.data.show_on_creating ? "表示する" : "表示しない";
          },
        },
        {
          headerName: "労務管理記録簿での集計有無",
          field: "show_on_record_book",
          minWidth: 220,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
          valueGetter: params => {
            return params.data.show_on_record_book ? "集計する" : "集計しない";
          },
        },
        {
          headerName: "登録種別",
          field: "is_custom",
          minWidth: 140,
          flex: 1,
          cellStyle: params => this.customizeCellStyle(params),
          valueGetter: params => {
            return params.data.is_custom ? "新規追加" : "デフォルト";
          },
        },

        {
          headerName: "操作",
          field: "action",
          minWidth: 50,
          maxWidth: 50,
          cellRendererFramework: "CellRendererRowActionButtons",
          pinned: "right",
          resizable: false,
          sortable: false,
          cellRendererParams: {
            edit: data => {
              this.setActionDialogEdit(data);
              this.showActionDialog = true;
            },
          },
          cellStyle: params => this.customizeCellStyle(params),
        },
      ];

      this.columnDefs = initialColumnDefs;
    },

    customizeCellStyle(params) {
      if (this.updatedTaskIds.includes(params.data.id)) {
        return { backgroundColor: "lightyellow" };
      } else {
        return null;
      }
    },
    getApproverFixed(roleId) {
      if (roleId == "2" || roleId == "8") {
        return false;
      } else {
        return true;
      }
    },
    setActionDialogEdit(rowData) {
      this.dialogTargetRowData = rowData;

      this.dialogSelectedColor = "#" + rowData.color_hex;
      this.dialogTaskKindName = rowData.label;
      this.dialogDefaultWorkingMinutes = rowData.default_working_minutes;
      this.dialogShowOnCreating = rowData.show_on_creating;
      this.dialogShowOnRecordBook = rowData.show_on_record_book;

      this.actionMode = "edit";
      this.actionDialogTitle = "作業種別編集";
    },
    setActionDialogAdd() {
      this.clearDialogForm();
      this.actionMode = "add";
      this.actionDialogTitle = "作業種別新規登録";
    },

    setDialogSelectedPeriod(dateList) {
      this.dialogSelectedPeriod = dateList.map(element =>
        moment(element).format("YYYY-MM-DD")
      );
    },
    clearDialogForm() {
      this.dialogTaskKindName = "";
      this.dialogSelectedColor = null;
      this.dialogDefaultWorkingMinutes = null;
      this.dialogShowOnCreating = true;
      this.dialogShowOnRecordBook = true;
      this.dialogTargetRowData = null;
    },
    onActionDialogCancel() {
      this.showActionDialog = false;
    },
    async onAdd() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const payload = {
          color_hex: this.dialogSelectedColor.replace("#", ""),
          default_working_minutes: this.dialogDefaultWorkingMinutes,
          label: this.dialogTaskKindName,
          show_on_creating: this.dialogShowOnCreating,
          show_on_record_book: this.dialogShowOnRecordBook,
        };
        const res = await enterpriseTimesheetTaskApi.add(payload);
        if (res.status == true) {
          this.updatedTaskIds.push(res.data.id);
          this.$vs.notify({
            title: `作業種別`,
            text: `${this.dialogTaskKindName}の作業種別を追加しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "作業種別の追加に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchTableData();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },
    async onEdit() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const payload = {
          color_hex: this.dialogSelectedColor.replace("#", ""),
          default_working_minutes: this.dialogDefaultWorkingMinutes,
          label: this.dialogTaskKindName,
          show_on_creating: this.dialogShowOnCreating,
          show_on_record_book: this.dialogShowOnRecordBook,
        };

        const taskId = this.dialogTargetRowData.id;
        const res = await enterpriseTimesheetTaskApi.update(taskId, payload);
        if (res.status == true) {
          this.updatedTaskIds.push(res.data.id);
          this.$vs.notify({
            title: `作業種別`,
            text: `${this.dialogTaskKindName}の作業種別を更新しました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "作業種別の更新に失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }

        this.showActionDialog = false;
        this.$vs.loading.close();
        this.fetchTableData();
      } catch (e) {
        this.showActionDialog = false;
        this.$vs.loading.close();
      }
    },

    async onManualSort(enterpriseCrewTaskIds) {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const res = await enterpriseTimesheetTaskApi.sort(
          enterpriseCrewTaskIds
        );
        if (res.status == true) {
          this.updatedTaskIds.push(res.data.id);
          this.$vs.notify({
            title: `作業種別`,
            text: `作業種別の並べ替えをしました`,
            color: "success",
            icon: "done",
          });
        } else {
          this.$vs.notify({
            title: "作業種別の並べ替えに失敗しました",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-square",
          });
        }
        this.$vs.loading.close();
        this.fetchTableData();
      } catch (e) {
        this.$vs.loading.close();
      }
    },

    clearSearchQueryString() {
      this.searchQueryString = "";
    },
    async fetchTableData() {
      this.$vs.loading({ color: this.AISEA_COLOR.BLUE });
      try {
        const res = await enterpriseTimesheetTaskApi.search({});
        this.tableData = res.data.list.map(task => {
          return {
            id: task.id,
            default_working_minutes: task.default_working_minutes,
            color_hex: task.color_hex,
            label: task.is_custom
              ? task.label
              : this.$t(`Views.Crew.LaborRecord.Tasks.${task.label}`),
            localized_key: task.localized_key,
            is_alert_target: task.is_alert_target,
            is_custom: task.is_custom,
            show_on_creating: task.show_on_creating,
            show_on_record_book: task.show_on_record_book,
            sort_order: task.sort_order,
          };
        });

        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

.task-kind-list-add-dialog {
  .vs-dialog {
    max-width: 520px;

    .vs-dialog-text {
      max-height: 90vh;
      overflow: auto;
    }
  }
  .form-item {
    margin-bottom: 24px;
    .form-item-title {
      font-weight: bold;
    }
  }
  .caution-text {
    font-size: 12px;
  }
  .required-mark {
    color: red;
  }

  .validation-label {
    color: red;
    margin-top: 4px;
    margin-bottom: 4px;
  }
}

#corp-manning-vessel-list {
  .vs-avatar--con-img img {
    object-fit: cover;
  }
  .ag-grid-table {
    height: 100%;

    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    .ag-header-cell-text {
      font-family: $aisea-font-family;
      font-size: 12px;
      font-weight: 600;
    }

    .ag-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
    .ag-header-cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .ag-header-cell {
    padding-right: 0;
  }
  .vs-tabs--content {
    padding: 4px 0 0 0;
  }

  .vs-pagination--ul {
    span {
      font-size: 12px;
      font-family: $aisea-font-family;
      font-weight: 400;
    }
  }
  .vue-treeselect__limit-tip-text {
    color: $aisea-blue !important;
  }

  .vue-treeselect--open .vue-treeselect__control {
    border-top-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__menu {
    box-shadow: 2px 5px 10px 0.5px #00000026;
    border-bottom-color: $aisea-blue !important;
    border-left-color: $aisea-blue !important;
    border-right-color: $aisea-blue !important;
  }

  .vue-treeselect__multi-value-item {
    color: $aisea-blue !important;
  }

  .vue-treeselect__control {
    width: 190px;
    height: 36px;
  }
}

.task-kind-list-add-dialog {
  .form-scroll-area {
    //max-height: 340px;
    //overflow-y: scroll;
    .dropdown-select {
      min-width: 160px;
      max-width: 160px;
    }
    .add-option-button {
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
